import { DependencyList, useEffect, useRef } from 'react'

// innerHTML does not execute <script> tags — recreating them does.
const executeScripts = (container: HTMLDivElement) => {
  container.querySelectorAll('script').forEach(oldScript => {
    const newScript = document.createElement('script')
    Array.from(oldScript.attributes).forEach(attr => newScript.setAttribute(attr.name, attr.value))
    newScript.textContent = oldScript.textContent
    oldScript.parentNode?.replaceChild(newScript, oldScript)
  })
}

export type CustomComponentSlotProps = {
  /** Merchant HTML to render. null/undefined renders nothing. */
  html?: string | null
  /**
   * Scripts are re-executed whenever any of these change (e.g. the checkout
   * object), so merchant code can re-read the latest window.Shopflo state.
   * Keep the array length stable across renders.
   */
  rerunDeps?: DependencyList
}

const CustomComponentSlot = ({ html, rerunDeps = [] }: CustomComponentSlotProps) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const hasHtml = html !== null && html !== undefined

  useEffect(() => {
    if (!containerRef.current) return
    if (!hasHtml) {
      containerRef.current.innerHTML = ''
      return
    }
    containerRef.current.innerHTML = html
    executeScripts(containerRef.current)
  }, [html]) // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!containerRef.current || !hasHtml) return
    executeScripts(containerRef.current)
  }, rerunDeps) // eslint-disable-line react-hooks/exhaustive-deps

  if (!hasHtml) return null
  return <div ref={containerRef} />
}

export default CustomComponentSlot
